import React, { FC, useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { IconButton } from "@evergis/ui";
import { GeometryType } from "@evergis/api";

import { useFeatureCreator } from "../../hooks/useFeatureCreator";
import { useResetGeometryEditor } from "../../hooks/useResetGeometryEditor";

import { EditGeometryType } from "../../../../evergis/core/attributes/geometryTypes";

interface FeatureCreateButtonProps {
  itemName?: string;
  geometryType?: GeometryType & EditGeometryType;
  disabled?: boolean;
  isLayerVisible: boolean;
}

export const FeatureCreateButton: FC<FeatureCreateButtonProps> = ({
  disabled,
  itemName,
  geometryType,
  isLayerVisible,
}) => {
  const { t } = useTranslation();
  const [editorActive, handleAddFeature] = useFeatureCreator(itemName, geometryType);
  const reset = useResetGeometryEditor();
  const title = editorActive ? t("actions.cancel", { ns: "common" }) : t("createFeature", { ns: "layerList" });

  useEffect(() => {
    if (!isLayerVisible && editorActive) {
      reset();
    }
  }, [isLayerVisible]);

  const onCreate = useCallback(
    (evt: React.MouseEvent<HTMLElement>) => {
      evt.stopPropagation();
      document.body.click();

      handleAddFeature();
    },
    [handleAddFeature],
  );

  return (
    <IconButton
      kind={"feature_add"}
      className="feature-create-button"
      title={title}
      primary={editorActive}
      disabled={disabled}
      onClick={onCreate}
    />
  );
};
